import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryWebsiteGoodsSeries(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-series`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGoodsSeries(goodsSeriesId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-series/${goodsSeriesId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  name
 * @param  coverPath
 * @param  coverPathMobile
 * @param  goldContent
 * @param thumbnail
 * @param  nameEn
 * @param description
 * @param isVip
 * @param descriptionEn
 * @param channel
 * @param seriesType
 * @param detailDescription
 * @param detailImage
 * @param menUse
 * @param originalStartPrice
 * @param originalEndPrice
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addGoodsSeries(
  {
    name,
    coverPath,
    coverPathMobile,
    goldContent,
    thumbnail,
    nameEn,
    description,
    isVip,
    descriptionEn,
    channel,
    seriesType,
    detailDescription,
    detailImage,
    menUse,
    originalStartPrice,
    originalEndPrice
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-series`,
    method: 'post',
    data: {
      name,
      coverPath,
      coverPathMobile,
      goldContent,
      thumbnail,
      nameEn,
      description,
      isVip,
      descriptionEn,
      seriesType,
      channel,
      detailDescription,
      detailImage,
      menUse,
      originalStartPrice,
      originalEndPrice
    },
  });
}

/**
 * 更新
 * @param goodsSeriesId
 * @param name
 * @param coverPath
 * @param coverPathMobile
 * @param goldContent
 * @param menUse
 * @param thumbnail
 * @param seriesType
 * @param nameEn
 * @param description
 * @param isVip
 * @param descriptionEn
 * @param channel
 * @param detailDescription
 * @param detailImage
 * @param originalStartPrice
 * @param originalEndPrice
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateGoodsSeries(goodsSeriesId, {
  name,
  coverPath,
  coverPathMobile,
  goldContent,
  thumbnail,
  seriesType,
  nameEn,
  description,
  isVip,
  descriptionEn,
  channel,
  detailDescription,
  detailImage,
  menUse,
  originalStartPrice,
  originalEndPrice
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-series/${goodsSeriesId}`,
    method: 'patch',
    data: {
      name,
      coverPath,
      coverPathMobile,
      goldContent,
      thumbnail,
      seriesType,
      nameEn,
      description,
      isVip,
      descriptionEn,
      channel,
      detailDescription,
      detailImage,
      menUse,
      originalStartPrice,
      originalEndPrice
    },
  });
}

/**
 * 删除
 * @param goodsSeriesId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGoodsSeries(goodsSeriesId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-series/${goodsSeriesId}`,
    method: 'delete',
  });
}

/**
 * 查询系列下的商品
 */
export function _queryGoodsSeriesGoods(
  {
    id, page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-series/goods`,
    method: 'get',
    params: {
      id,
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 推荐系列下的商品
 */
export function _recommendSeriesGoods(goodsSeriesId, goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-series/${goodsSeriesId}/${goodsId}/recommend`,
    method: 'patch',
  });
}

/**
 * 取消推荐
 */
export function _cancelRecommendGoods(goodsSeriesId, goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-series/${goodsSeriesId}/${goodsId}/cancel`,
    method: 'patch',
  });
}

/**
 * 拖拽排序
 * @returns
 */
export function _updateGoodsSort({
  idStr, sortStr, oldIndex, newIndex
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-series/update`,
    method: 'post',
    params: {
      idStr: idStr,
      sortStr: sortStr,
      oldIndex: oldIndex,
      newIndex: newIndex
    }
  });
}

export function _queryCategoryBySeriesId(goodsSeriesId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-series/${goodsSeriesId}/category`,
    method: 'get',
  });
}

export function _querySeriesByType(type) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-series/${type}/type`,
    method: 'get',
  });
}

export function _querySeriesCategory() {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-series/category`,
    method: 'get',
  });
}

